import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Actions
import {
  closeReportsSettingsForm,
  updateUserReportsSettings,
} from "../../actions/org/OrgUserManageActions";

// Constants
import { FormDataTargets } from "../../constants/GeneralConstants";

// Components
import CheckBox from "../check-box/CheckBox";

/**
 * Reports Settings Form
 */
export default function ReportsSettingsForm() {
  const dispatch = useDispatch();

  // state
  const [formData, setFormData] = useState({
    metrics: true,
    population: true,
    lts: true,
    hourlyTraffic: true,
    locationSummary: true,
  });

  // user reports settings
  const reportSettings = useSelector(
    (state) => state.orgUserManage.reportSettings
  );

  // reset
  useEffect(() => {
    setFormData({
      metrics: reportSettings.metrics,
      population: reportSettings.population,
      lts: reportSettings.lts,
      hourlyTraffic: reportSettings.hourlyTraffic,
      locationSummary: reportSettings.locationSummary,
    });
  }, []);

  // reports settings data
  const reportsSettingsData = [
    {
      id: "metrics",
      name: "metrics",
      labelText: "Metrics",
      checked: formData.metrics,
      metaData:
        "Impressions, TG Impressions, Reach, TG Reach, Frequency, Target Group Name",
    },
    {
      id: "lts",
      name: "lts",
      labelText: "LTS",
      checked: formData.lts,
      metaData:
        "LTS, LTS Rating, Avg LTS Rating, Radar Chart and Data (Aspect-Ratio, Area, Clutter, Elevation, Tilt)",
    },
    {
      id: "population",
      name: "population",
      labelText: "Population",
      checked: formData.population,
      metaData: "Population Count",
    },
    {
      id: "hourlyTraffic",
      name: "hourlyTraffic",
      labelText: "Hourly Traffic",
      checked: formData.hourlyTraffic,
      metaData: "Avg Dwell Time, Traffic Chart and Table",
    },
    {
      id: "locationSummary",
      name: "locationSummary",
      labelText: "Location Summary",
      checked: formData.locationSummary,
      metaData: "Pie Chart, Socio-economic Indicators, Landmarks Nearby",
    },
  ];

  // handle User Reports Settings
  function handleUpdate() {
    dispatch(updateUserReportsSettings(formData));

    // close form
    dispatch(closeReportsSettingsForm());
  }

  return (
    <div
      className="modal fade"
      id={FormDataTargets.reportsSettingsForm}
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          {/* Form Header */}
          <div className="modal-header bg-alt px-5">
            <h4 className="modal-title">{"Customize PDF Reports"}</h4>
          </div>

          {/* Form body */}
          <div className="modal-body px-5 py-4">
            <h5 className="mb-3">Select Options To Customize PDF Reports</h5>
            {reportsSettingsData.map((data) => {
              const { id, name, labelText, checked, metaData } = data;
              return (
                <div key={id} className="mb-3">
                  <CheckBox
                    boxStyle="p-0 mb-1 d-flex align-items-center"
                    inputBoxStyle="m-0 mr-1"
                    checked={checked}
                    checkBoxKey={labelText}
                    onChange={() =>
                      setFormData({ ...formData, [name]: !checked })
                    }
                  />
                  <label className="m-0 font-italic text-muted">{`- ${metaData}`}</label>
                </div>
              );
            })}
          </div>

          {/* Form Footer */}
          <div className="modal-footer border-0 px-5">
            <button
              type="button"
              className="btn btn-outline-primary btn-action mt-2 mr-3 rounded-lg shadow-none"
              data-dismiss="modal"
              onClick={() => dispatch(closeReportsSettingsForm())}
            >
              {"Cancel"}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-action mt-2 rounded-lg shadow-none"
              data-dismiss="modal"
              onClick={handleUpdate}
            >
              {"Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
